var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:_vm.buttonClassName,attrs:{"type":"button","disabled":_vm.isButtonDisabled},on:{"click":_vm.onClick}},[_vm._t("pre-icon"),_vm._v(" "),_vm._t("text"),_vm._v(" "),_vm._t("post-icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }